import moment from 'moment';
import { useShowContext } from 'framework/show';
import React from 'react';
import type { Data } from 'framework/types';
import { Box } from '@mui/material';

const HOURS_IN_DAY = 24;

const shouldRenderPastDueMark = (entity: Data) => {
  const activityDate = entity.getValueBySource('activityDate') ? moment(entity.getValueBySource('activityDate')) : null;
  const createdAtDate = entity.getValueBySource('createdAt') ? moment(entity.getValueBySource('createdAt')) : null;

  if (activityDate && createdAtDate) {
    const diff = createdAtDate.diff(activityDate, 'hours');
    if (diff > HOURS_IN_DAY) {
      return true;
    }
  }

  return false;
};

const PastDueMark = () => {
  const { data: entity } = useShowContext();

  return shouldRenderPastDueMark(entity) ? (
    <Box
      data-testid="past-due-mark"
      sx={{
        position: 'relative',
        display: 'inline-block',
        top: '3px',
        right: 0,
        fontSize: '22px',
        lineHeight: 1,
        color: 'error.main',
      }}
    >
      <i className="fa fa-exclamation-circle" title="Activity added too late" />
    </Box>
  ) : null;
};

export default PastDueMark;
